import { jsx as r } from "react/jsx-runtime";
import { w as m } from "../../../vendor-Dd6qj6gJ.js";
import { Surface as a } from "../../Surface/index.js";
import { Menu as n } from "../Menu/index.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as i } from "../../../utils/omitStyleRenderProps/index.js";
import '../../../assets/index31.css';const u = "_popover_1ur69_1", _ = "_surface_1ur69_28", o = {
  popover: u,
  surface: _
};
function N({
  isOpen: e,
  onOpenChange: t,
  triggerRef: p,
  placement: s,
  children: f,
  ...c
}) {
  return /* @__PURE__ */ r(
    m,
    {
      isOpen: e,
      onOpenChange: t,
      triggerRef: p,
      className: o.popover,
      offset: 0,
      placement: s,
      children: /* @__PURE__ */ r(a, { className: o.surface, children: /* @__PURE__ */ r(n, { ...i(c), children: f }) })
    }
  );
}
export {
  N as Content
};
